var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidePanelMessageCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0H3C1.34314 0 0 1.31384 0 2.93456V9.78187C0 11.4026 1.34314 12.7164 3 12.7164H3.6V15.2159C3.6 15.9007 4.43566 16.2552 4.94674 15.7872L8.3 12.7164H13C14.6569 12.7164 16 11.4026 16 9.78187V2.93456C16 1.31384 14.6569 0 13 0ZM3.4 4.6953C3.4 4.26311 3.75818 3.91275 4.2 3.91275H11.8C12.2418 3.91275 12.6 4.26311 12.6 4.6953C12.6 5.12748 12.2418 5.47785 11.8 5.47785H4.2C3.75818 5.47785 3.4 5.12748 3.4 4.6953ZM4.2 7.23858C3.75818 7.23858 3.4 7.58895 3.4 8.02113C3.4 8.45332 3.75818 8.80368 4.2 8.80368H9.6C10.0418 8.80368 10.4 8.45332 10.4 8.02113C10.4 7.58895 10.0418 7.23858 9.6 7.23858H4.2Z",
    fill: "#1D3679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidePanelMessageCenter);
export default __webpack_public_path__ + "static/media/sidePanelMessageCenter.285ca90b145b6cbda53c6e7dfa7ba141.svg";
export { ForwardRef as ReactComponent };